import { ReactNode, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import CookieConsent from "../CookieConsent";
import { initGA, logPageView } from "../../utils/analytics";

// Header, footer, cookie consent and page-view tracking for every public page
export default function PageShell({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [cookiesAccepted, setCookiesAccepted] = useState(() => localStorage.getItem("cookieConsent") === "true");

  useEffect(() => {
    if (cookiesAccepted) initGA();
  }, [cookiesAccepted]);

  useEffect(() => {
    if (cookiesAccepted) logPageView();
  }, [location.pathname, cookiesAccepted]);

  // Jump to #formules and similar anchors after client-side navigation
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
      return;
    }
    const target = document.querySelector(location.hash);
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [location.pathname, location.hash]);

  const handleAccept = useCallback(() => setCookiesAccepted(true), []);

  return (
    // overflow-x-clip: an entering animation must never widen the page (phones would zoom out)
    <div className="flex min-h-screen flex-col overflow-x-clip bg-white">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      {!cookiesAccepted && <CookieConsent onAccept={handleAccept} />}
    </div>
  );
}
